import { FunctionComponent } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { NavigationBlockItem } from '../NavigationBlockItem/NavigationBlockItem';
import { INavigationBlockEmptyProps } from './NavigationBlockEmpty.interface';

export const NavigationBlockEmpty: FunctionComponent<INavigationBlockEmptyProps> = ({ isEmpty, isLoading }) => {
  //TODO Ask for a design and make a good component instead of this...
  if (isEmpty) {
    return <NavigationBlockItem label={'No items'} href={null} />;
  }

  if (isLoading) {
    return <NavigationBlockItem label={' '} href={null} hoverAction={<CircularProgress size={24} />} />;
  }

  return null;
};
